import React from 'react';
import styled from 'styled-components';
import RepeatedControl from "../atoms/RepeatedControl";
import {useBoundStore} from "../../stores/useBoundStore";

const Holder = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
  margin: 0 0 2rem 0;

  button {
    border: 1px dotted transparent;
    padding: 0.5rem 1rem;
    width: calc((100% - 4rem) / 3);
    max-width: 8rem;
    white-space: normal;

    &.active {
      border-color: var(--color-1);
    }
  }

  p {
    ${(props) => props.theme.fluidType(-2)};
    text-align: center;
    padding-top: 0.5rem;
  }
`;

const RepeatHolder = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;

  .inner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const options = [
  'repeat',
  'mirror',
  'mirrorTwo'
];

function RepetitionPicker() {
  const repetition = useBoundStore(state => state.repetition);
  const setRepetition = useBoundStore(state => state.setRepetition);

  return (
    <Holder>
      {options.map((option, index) => {
        let label;
        if (option === 'repeat') {
          label = 'repeat';
        } else if (option === 'mirror') {
          label = 'mirrored over one axis';
        } else if (option === 'mirrorTwo') {
          label = 'mirrored over two axes';
        }
        return (
          <button key={index} className={repetition === option ? 'active' : ''} onClick={() => setRepetition(option)}>
            <RepeatHolder>
              <div className="inner">
                <RepeatedControl repeat={option} />
              </div>
            </RepeatHolder>
            <p>{label}</p>
          </button>
        );
      })}
    </Holder>
  )
}

export default RepetitionPicker;